'use strict';/* global define */define('modules/core/modules/utils/filters/new-line/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
function filterInit(){// jshint validthis:true
// jshint latedef:false
return function filter(text){if(text&&typeof text==='string'&&text.length){return text.replace(/\n/g,'<br>');}return text;};}module.exports=filterInit;});
